// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

import type { AutoSortAddressModelType } from './AutoSortRequest';
import { LatLng } from './LatLng';

export type MetadataModelType = {
    center: string,
    radius: string,
    provider: string,
    archive: array<string>,
    goodness: string,
    confidence: string,
    requestId: string,
    placeNameProvider: string,
    localityProvider: string,
    placeNameArchive: array<string>,
    localityArchive: array<string>
};

export type GeocodedLocationModelType = {
    id: string,
    address: AutoSortAddressModelType,
    metadata: MetadataModelType,
    latLng: LatLng,
    confidence: string,
    cleansedAddress: string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class Metadata extends ImmutableModel {
    static fromJS(json: MetadataModelType): Metadata {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): MetadataModelType {
        return {
            center: this.center,
            radius: this.radius,
            provider: this.provider,
            archive: this.archive,
            goodness: this.goodness,
            confidence: this.confidence,
            requestId: this.requestId,
            placeNameProvider: this.placeNameProvider,
            localityProvider: this.localityProvider,
            placeNameArchive: this.placeNameArchive,
            localityArchive: this.localityArchive
        };
    }

    get center(): string {
        return this._state.get('center');
    }

    setCenter(center: string): this {
        return this.clone(this._state.set('center', center));
    }

    get radius(): string {
        return this._state.get('radius');
    }

    setRadius(radius: string): this {
        return this.clone(this._state.set('radius', radius));
    }

    get provider(): string {
        return this._state.get('provider');
    }

    setProvider(provider: string): this {
        return this.clone(this._state.set('provider', provider));
    }

    get archive(): array<string> {
        return this._state.get('archive');
    }

    setArchive(archive: array<string>): this {
        return this.clone(this._state.set('archive', archive));
    }

    get goodness(): string {
        return this._state.get('goodness');
    }

    setGoodness(goodness: string): this {
        return this.clone(this._state.set('goodness', goodness));
    }

    get confidence(): string {
        return this._state.get('confidence');
    }

    setConfidence(confidence: string): this {
        return this.clone(this._state.set('confidence', confidence));
    }

    get requestId(): string {
        return this._state.get('requestId');
    }

    setRequestId(requestId: string): this {
        return this.clone(this._state.set('requestId', requestId));
    }

    get placeNameProvider(): string {
        return this._state.get('placeNameProvider');
    }

    setPlaceNameProvider(placeNameProvider: string): this {
        return this.clone(
            this._state.set('placeNameProvider', placeNameProvider)
        );
    }

    get localityProvider(): string {
        return this._state.get('localityProvider');
    }

    setLocalityProvider(localityProvider: string): this {
        return this.clone(
            this._state.set('localityProvider', localityProvider)
        );
    }

    get placeNameArchive(): array<string> {
        return this._state.get('placeNameArchive');
    }

    setPlaceNameArchive(placeNameArchive: array<string>): this {
        return this.clone(
            this._state.set('placeNameArchive', placeNameArchive)
        );
    }

    get localityArchive(): array<string> {
        return this._state.get('localityArchive');
    }

    setLocalityArchive(localityArchive: array<string>): this {
        return this.clone(this._state.set('localityArchive', localityArchive));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class GeocodedLocation extends ImmutableModel {
    static fromJS(json: GeocodedLocationModelType): GeocodedLocation {
        const state: Object = Object.assign({}, json);
        state.address = AutoSortAddress.fromJS(state.address);
        state.metadata = Metadata.fromJS(state.metadata);
        return new this(Immutable.Map(state));
    }

    toJS(): GeocodedLocationModelType {
        return {
            id: this.id,
            address: this.address.toJS(),
            metadata: this.metadata.toJS(),
            latLng: this.latLng,
            confidence: this.confidence,
            cleansedAddress: this.cleansedAddress
        };
    }

    get id(): string {
        return this._state.get('id');
    }

    setId(id: string): this {
        return this.clone(this._state.set('id', id));
    }

    get address(): AutoSortAddress {
        return this._state.get('address');
    }

    setAddress(address: AutoSortAddress): this {
        return this.clone(this._state.set('address', address));
    }

    get metadata(): Metadata {
        return this._state.get('metadata');
    }

    setMetadata(metadata: Metadata): this {
        return this.clone(this._state.set('metadata', metadata));
    }

    get latLng(): LatLng {
        return this._state.get('latLng');
    }

    setLatLng(latLng: LatLng): this {
        return this.clone(this._state.set('latLng', latLng));
    }

    get confidence(): string {
        return this._state.get('confidence');
    }

    setConfidence(confidence: string): this {
        return this.clone(this._state.set('confidence', confidence));
    }

    get cleansedAddress(): string {
        return this._state.get('cleansedAddress');
    }

    setCleansedAddress(cleansedAddress: string): this {
        return this.clone(this._state.set('cleansedAddress', cleansedAddress));
    }
}
